module.exports = __webpack_public_path__ + "static/media/kuh-5.5ac04778.png";